import { render, staticRenderFns } from "./ServiceProviderRightCol.vue?vue&type=template&id=316429e4&scoped=true&"
import script from "./ServiceProviderRightCol.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderRightCol.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderRightCol.vue?vue&type=style&index=0&id=316429e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316429e4",
  null
  
)

export default component.exports